export function truncateText(text, maxLength = 300, useWordBoundary = true) {
  if (!text || typeof text !== 'string') return '';

  if (text.length <= maxLength) return text;

  let truncated = text.slice(0, maxLength);

  if (useWordBoundary) {
    const lastSpace = truncated.lastIndexOf(' ');
    if (lastSpace > 0) {
      truncated = truncated.slice(0, lastSpace);
    }
  }

  return `${truncated}…`;
}
